import { theme } from 'antd';

const { useToken } = theme;

const MinusIcon = ({ color, width = 24, height = 24 }: { color?: string; width?: number; height?: number }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorText;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4119_143760)">
        <path d="M6.5 12H17.5" stroke={currentColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4119_143760">
          <rect width="16" height="16" fill={currentColor} transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MinusIcon;
